




























































































































import Component, { mixins } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import TextDayChangePicker from "@/components/common/TextDayChangePicker.vue";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import MonthMultiplePicker from "@/components/common/MonthMultiplePicker.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import BaseTable from "@/components/common/MergeBaseTable.vue";
import RightSideMenu from "@/components/common/RightSideMenu.vue";
import RadioGroupDialog from "@/components/common/RadioGroupDialog.vue";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import { HeaderWidthItem, SearchCondition, ObjectId } from "@/types";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import {
  YearmonthsState,
  SET_YEARMONTHS
} from "@/store/modules/yearmonths/types";
import { getStorageBoolean, getStorageNumber, dateJp } from "@/types";
import { AxiosResponse } from "axios";
import SelectFilter, { ColumnKey } from "@/components/common/SelectFilter.vue";
import { yearmonth } from "@/store/modules/yearmonth";
import { getDefaultMonth } from "@/types";

const StoreYearmonth = namespace("yearmonth");
const StoreYearmonths = namespace("yearmonths");

@Component({
  components: {
    TextDayChangePicker,
    TextMonthChangePicker,
    MonthMultiplePicker,
    BaseTable,
    LoadingDialog,
    RightSideMenu,
    RadioGroupDialog,
    SelectFilter
  }
})
export default class MedicalMerge extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;
  @Ref("previewTypeDialog")
  private readonly previewTypeDialog!: RadioGroupDialog;
  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;

  @State("yearmonths") yearmonthsState!: YearmonthsState;
  @StoreYearmonths.Mutation(SET_YEARMONTHS) setYearmonths!: Function;
  private get storeYearmonths() {
    return this.yearmonthsState.yearmonths;
  }
  private set storeYearmonths(yearmonths: string[]) {
    localStorage.setItem("yearmonths", JSON.stringify(this.yearmonths));
    this.setYearmonths(yearmonths);
  }
  private yearmonths: string[] = [];

  SPECIFICATION = 0;
  INVOICE = 1;
  MERGE = 2;
  private objectIdsBK: ObjectId[] = [];
  private CheckedOn = false;
  private downLoad = false;
  private searchYM = "";
  private useMultiMonth = "";

  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    this.setYearmonth(yearmonth);
  }

  private headerItems: HeaderWidthItem[] = [
    {
      value: "edit",
      text: "編集",
      width: "80px"
    },
    {
      value: "is_printed",
      text: "明細データ確定済",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_printed", val)
    },
    {
      value: "is_exec",
      text: "処理済日",
      width: "86px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_exec", val)
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px",
      filter: (val: object) => this.columnFilter("insured_no", val)
    },
    {
      value: "name",
      text: "氏名",
      width: "120px",
      filter: (val: object) => this.columnFilter("name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "120px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_no", val)
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "140px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_name", val)
    },
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "108px"
    }
  ];

  private multiMonthHeaderItems: HeaderWidthItem[] = [
    {
      value: "edit",
      text: "編集",
      width: "80px"
    },
    {
      value: "is_printed",
      text: "明細データ確定済",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_printed", val)
    },
    {
      value: "is_exec",
      text: "処理済日",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_exec", val)
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px",
      filter: (val: object) => this.columnFilter("insured_no", val)
    },
    {
      value: "name",
      text: "氏名",
      width: "120px",
      filter: (val: object) => this.columnFilter("name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "120px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_no", val)
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "140px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_name", val)
    },
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "108px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("yearmonth", val)
    }
  ];

  //------------------------------------------
  // SelectFilterの選択肢
  //------------------------------------------
  private get columnKeys(): ColumnKey[] {
    return this.headerItems
      .filter(hditm => {
        return hditm.filter != null;
      })
      .map(hditm => {
        let type = SelectFilter.FILTER_TYPE_EDIT;
        if (hditm.filterType != null) {
          type = hditm.filterType;
        }
        let selectable = null;
        if (
          hditm.filterType === SelectFilter.FILTER_TYPE_LIST ||
          hditm.filterType === SelectFilter.FILTER_TYPE_EDIT_LIST
        ) {
          //選択肢一覧作成
          selectable = this.tableItems
            .map(itm => {
              const txt = (itm as any)[hditm.value];
              return txt === "" ? SelectFilter.NO_DATA : txt;
            })
            .filter((val, idx, arr) => {
              return arr.indexOf(val) === idx;
            });
          //NO_DATAラベルを一覧の先頭に移動
          const idx = selectable.indexOf(SelectFilter.NO_DATA);
          if (idx > 0) {
            this.moveAt(selectable, idx, 0);
          }
        }
        const fkey: ColumnKey = {
          type: type,
          key: hditm.value,
          text: hditm.text,
          selectable: selectable
        };
        return fkey;
      });
  }

  //------------------------------------------
  // カラムフィルター
  //------------------------------------------
  private columnFilter(key: string, val: object) {
    const bret = this.selectFilter.isMatch(key, val);

    // テーブル更新
    if (this.baseTable) {
      this.baseTable.handle();
    }
    return bret;
  }

  private tableItems: object[] = [];

  private noExecs: object[] = []; //未処理データs
  private noExecCount = 0; //未処理件数
  private invoiceYMD: string = dateJp(new Date()).substr(0, 10); //請求書日付

  mounted() {
    // 検索条件設定
    const searchCondition: SearchCondition = {
      isDone: false,
      insuranceNo: "",
      insuranceName: "",
      userCode: "",
      userKana: "",
      userInsNo: ""
    };
    if (this.$route.query.only) {
      if (this.$route.query.only == "true") {
        searchCondition.isDone = true;
      }
    }
    if (typeof this.$route.query.insurance_no === "string") {
      searchCondition.insuranceNo = this.$route.query.insurance_no;
    }
    if (typeof this.$route.query.insurance_name === "string") {
      searchCondition.insuranceName = this.$route.query.insurance_name;
    }
    if (typeof this.$route.query.ibow_id === "string") {
      searchCondition.userCode = this.$route.query.ibow_id;
    }
    if (typeof this.$route.query.furigana === "string") {
      searchCondition.userKana = this.$route.query.furigana;
    }
    if (typeof this.$route.query.insured_no === "string") {
      searchCondition.userInsNo = this.$route.query.insured_no;
    }
    this.baseTable.setSearchCondition(searchCondition);
    this.yearmonths =
      JSON.parse(String(localStorage.getItem("yearmonths"))) ||
      this.storeYearmonths;
    // 画面復帰設定（チェックボックス、フィルタ条件）
    if (!this.$route.query.st) {
      this.baseTable.clearAllCheck();
      this.selectFilter.clearAll();
    } else {
      this.baseTable.restoreStorage();
      this.selectFilter.restoreStorage();
    }
    // 画面更新
    this.updateData(this.baseTable.getSearchCondition());
  }

  private updateData(searchCondition: SearchCondition) {
    this.postJsonCheck(
      window.base_url + "/api/office/medical/specification/get",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        yearmonths: this.yearmonths.map(yearmonth => yearmonth.replace("-", ""))
        // only_not_printed: searchCondition.isDone,
        // insurance_no: searchCondition.insuranceNo,
        // insurance_name: searchCondition.insuranceName,
        // ibow_id: searchCondition.userCode,
        // furigana: searchCondition.userKana,
        // insured_no: searchCondition.userInsNo
      },
      res => {
        this.searchYM = this.yearmonth.replace("-", ""); // 検索年月保持(Excelファイル名に使用)
        this.tableItems = res.data.specifications;
        this.noExecs = res.data.no_outputs;
        this.noExecCount = res.data.count;
        this.useMultiMonth = res.data.use_multi_month;
        if (this.useMultiMonth == "1") {
          // 複数月まとめ出力利用する場合はサービス提供年月をフィルタ可能にする
          this.headerItems = this.multiMonthHeaderItems;
        }
        this.$router.replace(`/medical/merge?st=1`).catch(err => err);
        this.$nextTick(() => {
          this.baseTable.restoreStorage();
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  private search(searchCondition: SearchCondition) {
    this.storeYearmonths = this.yearmonths;
    this.baseTable.clearAllCheck();
    this.updateData(searchCondition);
  }

  //明細書出力
  private doneSpecification(objectIds: ObjectId[]) {
    const isSamePrint = getStorageBoolean("isSamePrint", false);
    const isShahoRatioPrint = getStorageBoolean("isShahoRatioPrint", false);
    const isNengoPrint = getStorageBoolean("isNengoPrint", false);
    if (this.useMultiMonth == "0") {
      // 複数月まとめ出力機能利用しない場合現在の対象年月をセット
      this.yearmonths = [this.yearmonth];
    }
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/medical/specification",
      {
        yearmonths: this.yearmonths,
        ids: objectIds.map(objectId => objectId.id),
        is_same_print: isSamePrint,
        is_shaho_ratio_print: isShahoRatioPrint,
        is_nengo_print: isNengoPrint
      },
      res => {
        //最終出力処理で処理済みする場合
        if (this.CheckedOn) {
          this.checked(this.objectIdsBK);
          this.execChecked(this.objectIdsBK);
          this.CheckedOn = false;
        }
        if (this.downLoad) {
          this.dwonLoadPDF(res.data.pdf_path, "明細書");
        } else {
          window.open(res.data.pdf_path);
        }
        this.downLoad = false;
      }
    );
  }

  //請求書出力
  private doneInsinvoice(objectIds: ObjectId[]) {
    if (this.useMultiMonth == "0") {
      // 複数月まとめ出力機能利用しない場合現在の対象年月をセット
      this.yearmonths = [this.yearmonth];
    }
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/medical/insinvoice",
      {
        yearmonths: this.yearmonths,
        ids: objectIds.map(objectId => objectId.id),
        invoice_date: this.invoiceYMD
      },
      res => {
        //最終出力処理で処理済みする場合
        if (this.CheckedOn) {
          this.checked(this.objectIdsBK);
          this.execChecked(this.objectIdsBK);
          this.CheckedOn = false;
        }
        if (this.downLoad) {
          this.dwonLoadPDF(res.data.pdf_path, "請求書");
        } else {
          window.open(res.data.pdf_path);
        }
        this.downLoad = false;
      }
    );
  }

  //明細書・請求書出力
  private doneAll(objectIds: ObjectId[]) {
    const isSamePrint = getStorageBoolean("isSamePrint", false);
    const isShahoRatioPrint = getStorageBoolean("isShahoRatioPrint", false);
    const isNengoPrint = getStorageBoolean("isNengoPrint", false);
    if (this.useMultiMonth == "0") {
      // 複数月まとめ出力機能利用しない場合現在の対象年月をセット
      this.yearmonths = [this.yearmonth];
    }
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/medical/all",
      {
        yearmonths: this.yearmonths,
        ids: objectIds.map(objectId => objectId.id),
        invoice_date: this.invoiceYMD,
        is_same_print: isSamePrint,
        is_shaho_ratio_print: isShahoRatioPrint,
        is_nengo_print: isNengoPrint
      },
      res => {
        //最終出力処理で処理済みする場合
        if (this.CheckedOn) {
          this.checked(this.objectIdsBK);
          this.execChecked(this.objectIdsBK);
          this.CheckedOn = false;
        }
        if (this.downLoad) {
          this.dwonLoadPDF(res.data.pdf_path, "明細書・請求書");
        } else {
          window.open(res.data.pdf_path);
        }
        this.downLoad = false;
      }
    );
  }

  //確定
  private checked(objectIds: ObjectId[]) {
    const ids = objectIds.map(item => item.id);
    this.postJsonCheck(
      window.base_url + "/api/office/medical/specification/checked",
      {
        ids: ids
      },
      () => {
        this.updateData(this.baseTable.getSearchCondition());
      }
    );
  }

  //キャンセル
  private cancel(objectIds: ObjectId[]) {
    const ids = objectIds.map(item => item.id);
    this.postJsonCheck(
      window.base_url + "/api/office/medical/specification/cancel",
      {
        ids: ids
      },
      () => {
        this.updateData(this.baseTable.getSearchCondition());
      }
    );
    this.postJsonCheck(
      window.base_url + "/api/office/medical/insinvoice/cancel",
      {
        ids: ids
      },
      () => {
        this.updateData(this.baseTable.getSearchCondition());
      }
    );
  }

  //ダウンロード
  private download(objectIds: ObjectId[]) {
    const ids = objectIds.map(item => item.id);
    const param = {
      yearmonth: this.searchYM,
      ids: ids
    };
    const yy = this.yearmonth.split("-")[0];
    const mm = this.yearmonth.split("-")[1];
    const fname = `明細書詳細_${this.dateFormat(
      new Date()
    )}.xlsx`;

    this.postJsonBlobRes(
      window.base_url + "/api/office/medical/specification/excel",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  //請求データ削除
  private delData(objectIds: ObjectId[]) {
    if (objectIds.length === 0) {
      alert("削除対象の請求データが選択されていません。");
      return;
    }
    if (!confirm("選択された集計済み請求データを削除します。宜しいですか？")) {
      return;
    }

    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/recept/delete/medical",
      {
        ids: ids
      },
      () => {
        this.updateData(this.baseTable.getSearchCondition());
      }
    );
  }

  // 日付フォーマット(yyyyMMdd_HHmmss)
  private dateFormat(d: Date) {
    const ymd = `${d.getFullYear()}${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${d
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    const hms = `${d
      .getHours()
      .toString()
      .padStart(2, "0")}${d
      .getMinutes()
      .toString()
      .padStart(2, "0")}${d
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;
    return `${ymd}_${hms}`;
  }

  //編集画面に遷移
  private edit(item: ObjectId) {
    this.$router.push({
      path:
        "/medical/edit/" +
        item.patient_id +
        "?tab=specification&specification_id=" +
        item.id
    });
  }

  //最終出力処理
  private output(objectIds: ObjectId[]) {
    this.objectIdsBK = objectIds;
    this.downLoad = true;
    const type = getStorageNumber("mediinv-print-type");
    this.previewTypeDialog.open(type);
  }
  //最終出力処理(出力タイプ選択)
  private done(type: number) {
    localStorage.setItem("mediinv-print-type", type.toString());
    //処理済み設定
    this.CheckedOn = false;
    if (confirm("処理済みにしますか？")) {
      this.CheckedOn = true;
    }

    //PDF作成
    switch (type) {
      case this.SPECIFICATION:
        this.doneSpecification(this.objectIdsBK);
        break;
      case this.INVOICE:
        this.doneInsinvoice(this.objectIdsBK);
        break;
      case this.MERGE:
        this.doneAll(this.objectIdsBK);
        break;
    }
  }

  //処理済みチェック
  private execChecked(objectIds: ObjectId[]) {
    const ids = objectIds.map(item => item.id);
    this.postJsonCheck(
      window.base_url + "/api/office/medical/insinvoice/checked",
      {
        ids: ids
      },
      () => {
        this.updateData(this.baseTable.getSearchCondition());
      }
    );
  }

  private changeYear(yearmonth: string) {
    if (this.useMultiMonth == "1") {
      if (this.yearmonths.indexOf(yearmonth) == -1) {
        this.yearmonths.push(yearmonth);
      }
    } else {
      this.yearmonth = yearmonth;
    }
    this.updateData(this.baseTable.getSearchCondition());
  }

  //PDFダウンロード
  private dwonLoadPDF(url: string, typename: string) {
    this.loading = true;
    window.axios
      .get(url, {
        responseType: "blob"
      })
      .then((response: AxiosResponse) => {
        const blob = new Blob([response.data]);
        const a = document.createElement("a");
        a.download = `医療-${typename}.pdf`;
        a.href = URL.createObjectURL(blob);
        a.click();
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        alert("サーバでエラーが発生しました。");
        console.log(error);
        console.log(error.response);
      });
  }

  //------------------------------------------
  // 配列要素の移動
  //------------------------------------------
  private moveAt(array: object[], idx: number, at: number) {
    if (idx === at || idx > array.length - 1 || at > array.length - 1) {
      return;
    }
    const value = array[idx];
    const tail = array.slice(idx + 1);
    array.splice(idx);
    Array.prototype.push.apply(array, tail);
    array.splice(at, 0, value);
  }
}
